<template>
  <div class="imgBox min-w-1400">
    <div class="imgBox1 min-w-1400">
      <div class="img1Box max-w-1400">
        <img :src="importedImg1" alt="" class="imgItem1" />
      </div>
    </div>
    <div class="imgBox2 min-w-1400">
      <div class="img2Box max-w-1400">
        <img :src="importedImg2" alt="" class="imgItem2" />
      </div>
    </div>
    <div class="imgBox3 min-w-1400">
      <div class="img3Box max-w-1400">
        <img :src="importedImg3" alt="" class="imgItem3" />
      </div>
    </div>
    <div class="imgBox4 min-w-1400">
      <div class="img4Box max-w-1400">
        <img :src="importedImg4" alt="" class="imgItem4" />
      </div>
    </div>
    <div class="imgBox5 min-w-1400">
      <div class="img5Box max-w-1400">
        <img :src="importedImg5" alt="" class="imgItem5" />
      </div>
    </div>
    <div class="imgBox6 min-w-1400">
      <div class="img6Box max-w-1400">
        <!-- <img :src="importedImg6" alt="" class="imgItem6" /> -->
        <ul class="msg2">
          <li>
            <span>Nombre</span>
            <a-input
              class="inputBox"
              v-model="formValues.email"
              placeholder="Por favor, introduzca"
            >
              <!-- <template #suffix>
                <img :src="mailIcon" />
              </template> -->
            </a-input>
          </li>
          <li>
            <span>Correo</span>
            <a-input
              class="inputBox"
              v-model="formValues.mailName"
              placeholder="Por favor, introduzca"
            >
              <!-- <template #suffix>
                <img :src="mailIcon" />
              </template> -->
            </a-input>
          </li>
          <li>
            <span>Tu pregunta</span>
            <a-textarea
              class="textareaBox"
              v-model="formValues.remark"
              placeholder="Por favor, introduzca"
              :auto-size="{ minRows: 5, maxRows: 5 }"
            />
          </li>
          <li>
            <div>
              <a-button
                type="primary"
                :disabled="
                  formValues.mailName === '' || formValues.remark === ''
                "
                :class="{
                  submitButton: true,
                  btnBgcolor:
                    formValues.mailName !== '' && formValues.remark !== '',
                }"
                @click="submitFn"
                :loading="isLoading"
                >Enviar</a-button
              >
            </div>
          </li>
        </ul>
      </div>
    </div>
    <div class="imgBox7 min-w-1400">
      <div class="img7Box max-w-1400">
        <!-- <img :src="importedImg7" alt="" class="imgItem7" /> -->
      </div>
    </div>
  </div>
</template>

<script>
import "./index.css";
import { message } from "ant-design-vue";
import importedImg1 from "@/page/commuyservices/components/img/3_1.png";
import importedImg2 from "@/page/commuyservices/components/img/3_2.png";
import importedImg3 from "@/page/commuyservices/components/img/3_3.png";
import importedImg4 from "@/page/commuyservices/components/img/3_4.png";
import importedImg5 from "@/page/commuyservices/components/img/3_5.png";
// import importedImg6 from "@/page/commuyservices/components/img/3_6.png";
// import importedImg7 from "@/page/commuyservices/components/img/3_7.png";

export default {
  data() {
    return {
      importedImg1: importedImg1,
      importedImg2: importedImg2,
      importedImg3: importedImg3,
      importedImg4: importedImg4,
      importedImg5: importedImg5,
      // importedImg6: importedImg6,
      // importedImg7: importedImg7,
      altText: "图片",
      formValues: {
        mailName: "",
        email: "",
        remark: "",
      },
      isLoading: false,
    };
  },
  created() {
    this.gotoTop();
  },
  methods: {
    gotoTop() {
      window.scrollTo({ top: 0, behavior: "smooth" });
    },
    submitFn() {
      if (this.formValues.mailName === "" || this.formValues.remark === "") {
        message.info("Los elementos obligatorios no pueden estar vacíos");
        return;
      }
      this.isLoading = true;
      setTimeout(() => {
        this.isLoading = false;
        message.success(
          "El correo ha sido enviado con éxito y responderemos a tiempo."
        );
        this.formValues = {
          mailName: "",
          email: "",
          remark: "",
        };
      }, 2000);
    },
  },
};
</script>

<style scoped>
.imgBox {
  display: flex;
  flex-direction: column;
  background-color: white;
}

img {
  display: block;
}

.imgBox1,
.imgBox2,
.imgBox3,
.imgBox4,
.imgBox5,
.imgBox6,
.imgBox7 {
  display: flex;
  justify-content: center;
  width: 100%;
  background-color: "";
}

.img1Box,
.img2Box,
.img3Box,
.img4Box,
.img5Box,
.img6Box,
.img7Box {
  margin: 0;
  overflow: hidden;
  width: 100%;
  background-color: "";
}

.imgItem1,
.imgItem2,
.imgItem3,
.imgItem4,
.imgItem5,
.imgItem6,
.imgItem7 {
  width: 100%;
  margin: 0;
}
.img3Box {
  padding: 0 200px;
}

.img2Box,
.img4Box,
.img6Box {
  padding: 200px;
}

.msg2 {
  /* border: 1px solid red; */
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  gap: 20px;
}
.msg2 li {
  /* border: 1px solid red; */
  display: flex;
  flex-direction: column;
  width: 40%;
}

.msg2 li:nth-child(3) {
  width: 82%;
}
.msg2 li:nth-child(4) {
  width: 10%;
}

.msg2 li span {
  color: #000000;
  font-family: "Thonburi";
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  /* opacity: 0.6; */
  padding-bottom: 10px;
}
.msg2 li input,
textarea {
  all: unset; /* 移除所有默认样式 */
  border: none; /* 去除边框 */
  outline: none; /* 去除聚焦时的轮廓 */
  background: none; /* 去除背景 */
  color: inherit; /* 继承父元素的文本颜色 */
  font: inherit; /* 继承父元素的字体 */

  border: 2px solid transparent; /* 边框透明，才能看到渐变效果 */
  border-image: linear-gradient(to bottom, #d795ff, #b8ff9e); /* 渐变色 */
  border-image-slice: 1; /* 确保渐变填充整个边框 */
  border: 2px solid #d795ff;

  height: 30px;
  flex-shrink: 0;
  border-radius: 8px;
  /* background: #f8f6f4; */
  padding: 10px;
}

.msg2 li a {
  width: 200px;
  height: 50px;
  line-height: 50px;
  flex-shrink: 0;
  border-radius: 10px;
  background: #8a5d3c;
  color: #ffffff;
  text-align: center;
  font-family: "Thonburi";
  font-size: 20px;
  font-weight: 700;
}

.form {
  display: flex;
  flex-direction: column;
}

.inputBox {
  /* font-size: 18px;
  border: 2px solid #cdcdcd;
  border-radius: 10px;
  height: 50px; */
}

.inputBox >>> .ant-input {
  font-size: 18px;
  border: 2px solid #d795ff;
  border-radius: 10px;
  height: 56px;
  background-color: #ffffff;
}

/* .inputBox>>>.ant-input:focus {
  border: none;
  border-bottom: 1px solid white !important;
  box-shadow: 0 0 1px 2px #4263FF;
}

.inputBox>>>.ant-input:hover  {
  border: none;
  border-bottom: 1px solid white !important;
  box-shadow: 0 0 1px 2px #4263FF;
} */

.textareaBox {
  margin-top: 20px;
  border: 2px solid #d795ff;
  border-radius: 10px;
  font-size: 18px;
}
.textareaBox .ant-input {
  height: 200px;
}

.submitButton {
  background-color: #ffffff !important;
  color: #001c80;
  border: none;
  height: 40px;
  border-radius: 5px;
  margin-top: 170px;
  width: 120px;
  font-size: 18px;
}

.btnBgcolor {
  background-color: #000000 !important;
  color: #ffffff;
}

/* .submitButton:hover {
  background-color: #ffffff !important;
  color: #001C80;
} */

/* .imgItem2 {
  width: 80%;
  margin-top: 20px;
} */

.inp {
  display: flex;
}

.img6Box {
  padding: 100px 200px;
}

.ant-input:hover,
.ant-input:focus {
  border-color: #d795ff;
  border-right-width: 1px !important;
}
</style>
